import {createTheme} from "@mui/material";
import {GridColDef} from "@mui/x-data-grid";
import {Service} from "../../../models/Services";

export const theme = createTheme({
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    fontSize: '1.075rem',
                    border: 'none',
                    classes: "text-gray-600"
                },
                cell: {
                    ":focus": {outline: 'none'},
                    ":focus-within": {outline: 'none'},
                    whiteSpace: 'unset',
                    lineHeight: '1.2'
                },
                columnHeaderTitle: {
                    color: '#7E8299' // "text-gray-800",
                },
                columnHeader: {
                    ":focus": {outline: 'none'},
                    ":focus-within": {outline: 'none'}
                },
                iconSeparator: {
                    display: 'none'
                },
                columnHeaderTitleContainer: {
                    padding: 0
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: '#B5B5C3'
                }
            }
        }
    },
});

export const getColumns = (): GridColDef[] => [
    {
        field: 'name',
        headerName: 'Наименование услуги',
        width: 300
    },
    {
        field: 'period_fee',
        headerName: 'Стоимость',
        width: 100,
        sortable: false,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => Math.round(params.value)
    },
    {
        field: 'period_type',
        headerName: 'Тип периода',
        width: 70,
        sortable: false,
        hide: true,
    },
    {
        field: 'connection_fee',
        headerAlign: 'center',
        align: 'center',
        headerName: 'Подключение',
        sortable: false,
        width: 170,
        renderCell: (params) => Math.round(params.value)
    },
    {
        field: 'category_type',
        type: 'boolean',
        headerName: 'Категория услуг',
        width: 150,
        hide: true,
        renderCell: (params) => params.row.name
    },
]

export const getRows = (serviceList: Service[] | undefined): any => serviceList?.map((service) =>
    ({
        ...service,
        id: service.service_id,
    })
)
